import dayjs from "dayjs";
import ls from "local-storage";
import { useQuery } from "react-query";

import { INITIAL_SUBMIT } from "../../../constants";
import { fetchDidacticYears } from "../../../services/gatewayDataTables";

const generateInitialValues = (
  id,
  applicationData,
  documents,
  TranslatedEducationLevel,
  TranslatedRetiredOptions,
  translatedGender,
  PrfcsData,
  PortAuthoritiesData,
  fetchBirthCountries
) => {
  // Set color for checkboxes
  if (applicationData?.[0]?.nautical_pd_color) {
    ls.set("nauticalPdColor", applicationData?.[0]?.nautical_pd_color);
  }

  return {
    id,
    available_statuses: null,
    history_comment: "",
    appl_kind_id: applicationData?.[0]?.appl_kind_id,
    applicationKind: applicationData?.[0]?.applicationKind || "",
    port_authority_id: applicationData?.[0]?.port_authority_id,
    pickup_place_id: applicationData?.[0]?.pickup_place_id,
    pickup_place:
      PortAuthoritiesData?.find(
        (item) => item.id === applicationData?.[0]?.pickup_place_id
      ) || " ",
    portAuthority:
      PortAuthoritiesData?.find(
        (item) => item.id === applicationData?.[0]?.port_authority_id
      ) || "",
    appl_dt: dayjs(applicationData?.[0]?.appl_dt).format("DD/MM/YYYY") || "",
    reg_num: applicationData?.[0]?.reg_num || "",
    lname_ait: applicationData?.[0]?.lname_ait || "",
    fname_ait: applicationData?.[0]?.fname_ait || "",
    afm_ait: applicationData?.[0]?.afm_ait || "",
    ind_nr_ait: applicationData?.[0]?.ind_nr_ait || "",
    fath_lname_ait: applicationData?.[0]?.fath_lname_ait || "",
    fath_fname_ait: applicationData?.[0]?.fath_fname_ait || "",
    address_ait: applicationData?.[0]?.address_ait || "",
    address_nr_ait: applicationData?.[0]?.address_nr_ait || "",
    tk_ait: applicationData?.[0]?.tk_ait || "",
    tel_ait: applicationData?.[0]?.tel_ait || "",
    mobile_ait: applicationData?.[0]?.mobile_ait || "",
    email_ait: applicationData?.[0]?.email_ait || "",
    lname_afora: applicationData?.[0]?.lname_afora || "",
    fname_afora: applicationData?.[0]?.fname_afora || "",
    afm_afora: applicationData?.[0]?.afm_afora || "",
    ind_nr_afora: applicationData?.[0]?.ind_nr_afora || "",
    fath_lname_afora: applicationData?.[0]?.fath_lname_afora || "",
    fath_fname_afora: applicationData?.[0]?.fath_fname_afora || "",
    moth_lname_afora: applicationData?.[0]?.moth_lname_afora || "",
    moth_fname_afora: applicationData?.[0]?.moth_fname_afora || "",
    dt_birth_afora: new Date(applicationData?.[0]?.dt_birth_afora) || "",
    place_birth_afora:
      PrfcsData?.find(
        (item) => item.id === applicationData?.[0]?.place_birth_afora
      ) || "",
    dimos_diamonis_afora:
      PrfcsData?.find(
        (item) =>
          item.id === parseInt(applicationData?.[0]?.dimos_diamonis_afora)
      ) || "",
    address_afora: applicationData?.[0]?.address_afora || "",
    address_nr_afora: applicationData?.[0]?.address_nr_afora || "",
    tk_afora: applicationData?.[0]?.tk_afora || "",
    tel_afora: applicationData?.[0]?.tel_afora || "",
    mobile_afora: applicationData?.[0]?.mobile_afora || "",
    email_afora: applicationData?.[0]?.email_afora || "",
    status: applicationData?.[0]?.status || INITIAL_SUBMIT,
    oldStatus: applicationData?.[0]?.status,
    amka_afora: applicationData?.[0]?.amka_afora,
    meth_afora: applicationData?.[0]?.meth_afora,
    amka_ait: applicationData?.[0]?.amka_ait,
    meth_ait: applicationData?.[0]?.meth_ait,
    sector: applicationData?.[0]?.sector,
    rndv_from: applicationData?.[0]?.rndv_from,
    rndv_to: applicationData?.[0]?.rndv_to,
    comments: "",
    uploadedDocuments: documents,
    epipedo_ekpaideusis_afora: TranslatedEducationLevel.find(
      (option) => option.id == applicationData?.[0]?.epipedo_ekpaideusis_afora
    ),
    sintaksiouxos_afora: applicationData?.[0]?.sintaksiouxos_afora
      ? applicationData?.[0]?.sintaksiouxos_afora.toString()
      : null,
    topos_eggrafis_dimotologiou_ellada:
      applicationData?.[0]?.topos_eggrafis_dimotologiou_ellada,
    gender_afora: translatedGender.find(
      (option) => option.id == applicationData?.[0]?.gender_afora
    ),
    nationality_afora: applicationData?.[0].nationality_afora,
    read_dilosi_idiotiton: applicationData?.[0]?.read_dilosi_idiotiton || null,
    reason_for_copy_nautical_issue: applicationData?.[0]
      ?.reason_for_copy_nautical_issue
      ? applicationData?.[0]?.reason_for_copy_nautical_issue.toString()
      : null,
    didacticYear:
      applicationData?.[0]?.didactic_year_id &&
      applicationData?.[0].didactic_year
        ? {
            id: applicationData?.[0]?.didactic_year_id,
            dscr: applicationData?.[0]?.didactic_year,
          }
        : null,
    nauticalPdColor: applicationData?.[0]?.nautical_pd_color,
    birth_country:
      fetchBirthCountries?.find(
        (item) => item.id === applicationData?.[0]?.birth_country_id
      ) || " ",
  };
};

export default generateInitialValues;
